import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { AsciiWave } from './AsciiWave';
import { EmblemFly } from './EmblemFly';

const ORBS = [1, 2, 3, 4, 5] as const;

/**
 * Фон: м’який градієнт і кілька кіл акценту. Нерухомий: під склом кожен рух
 * фону — це перерахунок розмиття всіх плиток (див. base.css).
 * `layer="app"` — всередині `.app-main` налаштувань, щоб скло плиток бачило
 * фон у blur (там .app-main прокручується сам).
 */
export function AmbientBg({ layer = 'root' }: { layer?: 'root' | 'app' }): ReactNode {
  const host = typeof document !== 'undefined' ? document.getElementById('ambient-root') : null;
  const node = (
    <div className={`ambient-bg${layer === 'app' ? ' in-app' : ''}`} aria-hidden>
      {/* Першими: wash і плями лягають зверху — символи проступають крізь градієнт. */}
      <AsciiWave />
      <EmblemFly />
      <div className="ambient-wash" />
      {ORBS.map(n => (
        <span key={n} className={`ambient-orb o${n}`} />
      ))}
    </div>
  );
  if (layer === 'app') return node;
  if (!host) return null;
  return createPortal(node, host);
}
